export const SHOW_IMAGE_PREVIEW = 'SHOW_IMAGE_PREVIEW';
export const HIDE_IMAGE_PREVIEW = 'HIDE_IMAGE_PREVIEW';

export const showImagePreview = url => ({
  type: SHOW_IMAGE_PREVIEW,
  url,
});

export const hideImagePreview = () => ({
  type: HIDE_IMAGE_PREVIEW,
});



// WEBPACK FOOTER //
// ./app/actions/ImagePreviewActionCreators.js